<p>dashboard-category-chart-widget works!</p>
